import { createBrowserHistory } from 'history'
export default createBrowserHistory()


// WEBPACK FOOTER //
// ./src/app/history.js